import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
} from "@mui/material";
import { useProductCacheDetail } from "../../../hooks/useProductCacheAdmin";

interface ProductCacheDetailModalProps {
  open: boolean;
  onClose: () => void;
  productId: string;
  retailer: string;
}

const ProductCacheDetailModal: React.FC<ProductCacheDetailModalProps> = ({
  open,
  onClose,
  productId,
  retailer,
}) => {
  const { t } = useTranslation();
  const { data, isLoading } = useProductCacheDetail(productId, retailer, open);

  const productDetail = data?.data;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t("admin.productCache.cacheDetails")}</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Typography>{t("common.loading")}</Typography>
        ) : productDetail ? (
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              {t("admin.productCache.productId")}: {productDetail.productId}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              {t("admin.productCache.retailer")}: {productDetail.retailer}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              {t("admin.productCache.cached")}: {new Date(productDetail.cachedAt).toLocaleString()}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              {t("admin.productCache.updated")}: {new Date(productDetail.updatedAt).toLocaleString()}
            </Typography>
            {productDetail.expiresAt && (
              <Typography variant="subtitle2" gutterBottom>
                {t("admin.productCache.expires")}: {new Date(productDetail.expiresAt).toLocaleString()}
              </Typography>
            )}
            <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
              {t("admin.productCache.productDataJson")}:
            </Typography>
            <Paper
              sx={{
                p: 2,
                backgroundColor: "#f5f5f5",
                maxHeight: 400,
                overflow: "auto",
              }}
            >
              <pre style={{ margin: 0, fontSize: "12px" }}>
                {JSON.stringify(JSON.parse(productDetail.productDataJson), null, 2)}
              </pre>
            </Paper>
          </Box>
        ) : (
          <Typography>{t("admin.productCache.productNotFound")}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductCacheDetailModal;

